import React, {Component} from 'react';
import {getAddressList} from '../../data/user_api';
import {PROPERTY_API_URL} from "../../constants/api_routes";
import {Button, Dropdown,Segment,Grid,Divider,Header,Icon} from 'semantic-ui-react';

class PropertyAddressSearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addresses: [],
            selectedAddressId: undefined,
            selectedAddress: undefined,
            isFetching: true
        }
    }

    componentWillMount() {
        this.getPropertyAddressList().then(() => {
            this.setState({isFetching: false})
        });
    }

    getPropertyAddressList = async () => {
        const addressList = await getAddressList(PROPERTY_API_URL);
        let addressOptions = [];
        for (let i = 0; i < addressList.length; i++) {
            let obj = {
                key: addressList[i].id,
                text: addressList[i].address,
                value: addressList[i].id,
                address: addressList[i]
            };
            addressOptions.push(obj);
        }
        this.setState({addresses: addressOptions});
    };

    useAddress = () => {
        const addressDetail = this.state.addresses.filter((e) => {
            return e.address.id === this.state.selectedAddressId;
        });
        this.props.addressSelected(true, this.state.selectedAddressId, addressDetail[0]['address']);
    };

    render() {
        return (<div className="additional-pad">
            <Segment className="placeholder">
                <Grid columns={2} stackable textAlign='center' style={{marginTop:'0'}}>
                    <Divider vertical>Or</Divider>

                    <Grid.Row verticalAlign='middle' style={{height:'300px'}}>
                        <Grid.Column>
                            <Header icon>
                                <Icon name='search'/>
                                From Existing Address
                            </Header>

                            <Dropdown
                                placeholder='Address'
                                search
                                noResultsMessage="Property Not Found"
                                selection
                                loading={this.state.isFetching}
                                fluid
                                icon="search"
                                value={this.state.selectedAddress}

                                onChange={(e, option) => {
                                    this.setState({selectedAddressId: option.value})
                                }}
                                options={this.state.addresses}/>
                            <div className="pad-top">
                                {this.state.selectedAddressId &&
                                <Button content="Use this Address >>" primary onClick={this.useAddress}/>}
                            </div>
                        </Grid.Column>

                        <Grid.Column>
                            <Header icon>
                                <Icon name='world'/>
                                Add New Address
                            </Header>
                            <div>
                            <Button primary onClick={() => this.props.addressSelected(false, undefined, {})}>Create New</Button>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
        </div>);
    }
}

export default PropertyAddressSearch;


// WEBPACK FOOTER //
// ./src/views/properties/property_address_select.js